import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import {
  ButtonComponent,
  ToastComponent,
} from '@sarasanalytics-com/design-system';
import { IToast } from 'src/app/interfaces/toast-interface';
import { SignupService } from 'src/app/services/signup/signup.service';
import { TrackingService } from 'src/app/services/tracking/tracking.service';
import {
  IMessageView,
  MessageViewComponent,
  MessageViewEvent,
} from 'src/app/shared/components/message-view/message-view.component';
import { loginEmailProps } from 'src/app/static/form';
import {
  forgotPasswordSuccess,
  SignupEmailVerificationFailure,
  SignupSuccess,
  verifyEmailExpired,
  workEmailNotVerified,
} from 'src/app/static/message-view';
import { NS_Enums } from 'src/app/static/namespace';
import { normalizeEmail } from 'src/app/shared/email.helper';

@Component({
  selector: 'sa-work-email-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    FormsModule,
    ButtonComponent,
    ToastComponent,
    MessageViewComponent,
  ],
  templateUrl: './work-email-form.component.html',
  styleUrl: './work-email-form.component.scss',
})
export class WorkEmailFormComponent {
  form: FormGroup;
  model: any = {};
  fields: FormlyFieldConfig[] = [];

  toast: IToast | null;
  messageView: IMessageView | null; // = forgotPasswordSuccess('sairaj.kujala@sarasanalytics.com');
  private signupService: SignupService = inject(SignupService);
  private trackingService: TrackingService = inject(TrackingService);

  ngOnInit() {
    this.form = new FormGroup({});
    this.generateForm();
  }
  onSubmit() {
    if (this.form.valid) {
      this.toast = null;
      this.signupService.forgotPassword(this.model.email).subscribe({
        next: (response) => {
          if (response.success) {
            this.messageView = forgotPasswordSuccess(this.model.email);
            this.trackingService.trackCustomEvent(NS_Enums.trackingCustomEvents.RESET_LINK_SENT, {email: this.model.email});
          } else {
            if(response.code === "E0002"){
              this.messageView = workEmailNotVerified(this.model.email);
              this.trackingService.trackCustomEvent(NS_Enums.trackingCustomEvents.RESET_USER_NOT_VERIFIED, {email: this.model.email});
            }else{
              this.toast = {};
              this.toast.status = 'failure';
              this.toast.subHeading = toastfailureMsg; 
              this.trackingService.trackCustomEvent(NS_Enums.trackingCustomEvents.RESET_LINK_SENT_FAILED, {email: this.model.email});
            }
          }
        },
        error: (err) => {},
      });
    }else{
      this.form.markAllAsTouched();
    }
  }
  modelChangeHandler(evt: any) {
    // console.log(evt, this.form.valid);
  }
  generateForm() {
    this.fields = [
      {
        key: 'email',
        type: 'sa-input',
        className: '',
        props: loginEmailProps(),
      },
    ];
  }
  onMessageViewEvent(evt: any) {
    switch (evt.type) {
      case MessageViewEvent.REFRESH:
        break;
      case MessageViewEvent.RESEND: {
        /* In case when user did not verify email tries to reset password */
        this.signupService.sendVerificationEmail('', this.model.email).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.trackingService.trackCustomEvent(NS_Enums.trackingCustomEvents.RESET_RESEND_LINK, {email: normalizeEmail(this.model.email)});
              this.messageView = SignupSuccess(this.model.email || '');
            } else {
              this.trackingService.trackCustomEvent(NS_Enums.trackingCustomEvents.RESET_RESEND_LINK_FAILED, {email: normalizeEmail(this.model.email)});
              this.messageView = SignupEmailVerificationFailure(
                this.model.email || ''
              );
            }
          },
        });
        break;
      }
    }
  }
}

const toastfailureMsg = `We couldn't send the password reset link. Please enter an email associated with your Saras account.`;
